import SideMenu from '@/containers/side-menu/SideMenu.vue';
import ConsumerList from '@/pages/consumer-list/ConsumerList.vue';

export default {
  path: '/consumer/list',
  name: 'ConsumerList',
  components: {
    mainContent: ConsumerList,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'consumer-list',
    },
    breadcrumb: {
      title: 'Listagem de Clientes',
      paths: [{ title: 'Atendimento' }, { title: 'listagem' }],
    },
  },
};
